import * as React from 'react';

import { cn } from '~/lib/utils';

export function Dialog({
  open,
  onOpenChange,
  children
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}) {
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onOpenChange(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onOpenChange]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60]">
      <button
        type="button"
        className="fixed inset-0 bg-black/50"
        aria-label="Close dialog"
        onClick={() => onOpenChange(false)}
      />
      <div
        className="fixed inset-0 flex items-center justify-center overflow-y-auto p-4 pointer-events-none"
        onClick={() => onOpenChange(false)}
      >
        <div
          className="pointer-events-auto my-auto w-full max-w-[calc(100vw-2rem)]"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export function DialogPanel({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className={cn(
        'mx-auto w-full max-w-md rounded-lg border bg-card p-6 text-card-foreground shadow-lg',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
